export default "__VITE_ASSET__Da6vEIJp__";